import { render, staticRenderFns } from "./ConfirmationDocs.vue?vue&type=template&id=0392f5c4&scoped=true&"
import script from "./ConfirmationDocs.vue?vue&type=script&lang=js&"
export * from "./ConfirmationDocs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0392f5c4",
  null
  
)

export default component.exports